export const data = {
    result: "SUCCESS",
    message: "Processed Successfully!",
    data: {
      user: {
        id: 710,
        firstName: "Chander Shekhar",
        lastName: "Saini",
        radiologistType: 0,
        showAllStudies: false,
        showWelcomeMessage: false,
        showConfirmation: false,
        showRadiologistTime: false,
      },
      showAllStudies: false,
      clientFirmList: [
        {
          id: 605,
          name: "adasd",
          code: "Fadasdoh89N778b2yCrzMS20GrmLyg",
        },
        {
          id: 595,
          name: "AndersonGateway",
          code: "FAndersonGatewayUWQ2Yv6MtUrRp3",
        },
        {
          id: 603,
          name: "deeptek",
          code: "Fdeeptek9BcJ2IVUmoHpF3Oz7WvH3E",
        },
        {
          id: 588,
          name: "Demo",
          code: "FDemobqKjcOGBl8Nvuywjnbitw2udD",
        },
        {
          id: 590,
          name: "Hospital Eight",
          code: "FHospitalEightwSOXPjMyUe3VMsQC",
        },
        {
          id: 594,
          name: "Hospital Eleven",
          code: "FHospitalEleven7V3WSEkGPZKoEYC",
        },
        {
          id: 583,
          name: "Hospital Five",
          code: "FHospitalFiveCPcEqyXk958EnGbmX",
        },
        {
          id: 581,
          name: "Hospital Four",
          code: "FHospitalFour8tsl4fN9xLElhpP2C",
        },
        {
          id: 591,
          name: "Hospital Nine",
          code: "FHospitalNineKafJkTBAreRBOdW8Y",
        },
        {
          id: 577,
          name: "Hospital One",
          code: "FHospitalOne4xOZnh8UkzKxYGlj6k",
        },
        {
          id: 585,
          name: "Hospital Seven",
          code: "FHospitalSeven5M9ErGqgeFubyQ19",
        },
        {
          id: 584,
          name: "Hospital Six",
          code: "FHospitalSixxKYPPhh1twNnGiRY1y",
        },
        {
          id: 592,
          name: "Hospital Ten",
          code: "FHospitalTen5XqKcGq2otGvUcHS5H",
        },
        {
          id: 579,
          name: "Hospital Three",
          code: "FHospitalThreePGHGltAzCOqjx4rL",
        },
        {
          id: 578,
          name: "Hospital Two",
          code: "FHospitalTwoCrbHTvxfh5r3ECGKwn",
        },
        {
          id: 589,
          name: "IhisTestingHosp1",
          code: "FIhisTestingHosp11Pl4kM2hETHBa",
        },
        {
          id: 604,
          name: "jkas",
          code: "FjkasGksg6CiU6AKaNwx9Ylic4JxAj",
        },
        {
          id: 587,
          name: "MPR Test",
          code: "FMPRTesttkBscfCb171mcLYktpLiTI",
        },
        {
          id: 582,
          name: "sampdmap",
          code: "FsampdmapMcaw2qivXcH7y9KXoXaPX",
        },
        {
          id: 586,
          name: "sharvil test",
          code: "FsharviltestQcj4xaXp0Y5Z9Jz8bU",
        },
        {
          id: 601,
          name: "test",
          code: "Ftestz8MGrvnokQctoS9acWQJQkx2S",
        },
        {
          id: 580,
          name: "test hosp",
          code: "Ftesthospv9alPoJhpZPnV1Na52Dkh",
        },
        {
          id: 600,
          name: "Test Hospital Four",
          code: "FHospitalOne&OneB18hMeMih42PHO",
        },
        {
          id: 596,
          name: "Test Hospital One",
          code: "FTestHospitalOnewuMjkP8XhzE5gT",
        },
        {
          id: 598,
          name: "Test Hospital Three",
          code: "FTestHospitalThree4agf6NsLo1nj",
        },
        {
          id: 597,
          name: "Test Hospital Two",
          code: "FTestHospitalTwoIoglqSNWVFz32M",
        },
        {
          id: 593,
          name: "testhospital",
          code: "FtesthospitalpdofljffXGQc5Pmk0",
        },
        {
          id: 599,
          name: "testhospone",
          code: "FtesthosponedEj4n3LmdFERFJUCkz",
        },
        {
          id: 602,
          name: "testhosptwo",
          code: "FtesthosptwolVsEGRAI8JRxaME4nD",
        },
      ],
      providerFirmList: [],
      radiologistList: [
        {
          id: 761,
          firstName: "fradone",
          lastName: "lradone",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 734,
          firstName: "ioinoin",
          lastName: "inoinio",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 760,
          firstName: "kam",
          lastName: "ran",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 756,
          firstName: "Kamaran",
          lastName: "Ahmed",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 735,
          firstName: "piji",
          lastName: "onoinio",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 773,
          firstName: "radtwo",
          lastName: "radtwo",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 817,
          firstName: "tesr",
          lastName: "radfourt",
          radiologistType: 3,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 818,
          firstName: "test",
          lastName: "radfift",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 819,
          firstName: "test",
          lastName: "radfift",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 820,
          firstName: "test",
          lastName: "radfift",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 745,
          firstName: "Test Radiologist",
          lastName: "Eight",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 743,
          firstName: "Test Radiologist",
          lastName: "Five",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 742,
          firstName: "Test Radiologist",
          lastName: "Four",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 750,
          firstName: "Test Radiologist",
          lastName: "Nine",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 720,
          firstName: "Test Radiologist",
          lastName: "One",
          radiologistType: 3,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 726,
          firstName: "Test Radiologist",
          lastName: "Three",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 725,
          firstName: "Test Radiologist",
          lastName: "Two",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 812,
          firstName: "testrad",
          lastName: "html",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 762,
          firstName: "testrad",
          lastName: "ten",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 755,
          firstName: "testrad",
          lastName: "testradone",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 814,
          firstName: "testrad",
          lastName: "thir",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 815,
          firstName: "testrad",
          lastName: "thir",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 816,
          firstName: "testrad",
          lastName: "thir",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 744,
          firstName: "testradseven",
          lastName: "test",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
        {
          id: 811,
          firstName: "tets",
          lastName: "asd",
          radiologistType: 1,
          showAllStudies: true,
          showWelcomeMessage: true,
          showConfirmation: false,
          showRadiologistTime: false,
        },
      ],
      modalityList: [
        {
          id: 1,
          name: "DX",
          description: "Digital Radiography",
        },
        {
          id: 2,
          name: "CT",
          description: "Computed Tomography",
        },
        {
          id: 3,
          name: "CR",
          description: "Conventional X-ray",
        },
        {
          id: 4,
          name: "MR",
          description: "Magnetic Resonance",
        },
        {
          id: 5,
          name: "OT",
          description: "Other",
        },
        {
          id: 6,
          name: "PT",
          description: "Positron emission tomography (PET)",
        },
        {
          id: 7,
          name: "PR",
          description: "Presentation State",
        },
        {
          id: 8,
          name: "RG",
          description: "Radiographic imaging ",
        },
        {
          id: 10,
          name: "SR",
          description: "SR Document",
        },
        {
          id: 11,
          name: "RF",
          description: "Radio Fluoroscopy",
        },
        {
          id: 12,
          name: "US",
          description: "Ultrasound",
        },
        {
          id: 13,
          name: "MG",
          description: "Mammography",
        },
        {
          id: 14,
          name: "KO",
          description: "Key Object Selection",
        },
        {
          id: 15,
          name: "HC",
        },
        {
          id: 16,
          name: "SC",
        },
        {
          id: 17,
          name: "DOC",
        },
        {
          id: 18,
          name: "DR",
        },
        {
          id: 19,
          name: "PX",
        },
      ],
      annotationList: [
        {
          name: "Atelectasis",
          active: true,
          defaultName: "Atelectasis",
        },
        {
          name: "Cardiomegaly",
          active: true,
          defaultName: "Cardiomegaly",
        },
        {
          name: "Pleural Effusion",
          active: true,
          defaultName: "Pleural Effusion",
        },
        {
          name: "Mass",
          active: true,
          defaultName: "Mass",
        },
        {
          name: "Nodule",
          active: true,
          defaultName: "Nodule",
        },
        {
          name: "Pneumonia",
          active: true,
          defaultName: "Pneumonia",
        },
        {
          name: "Pneumothorax",
          active: true,
          defaultName: "Pneumothorax",
        },
        {
          name: "Consolidation",
          active: true,
          defaultName: "Consolidation",
        },
        {
          name: "Pulmonary Edema",
          active: true,
          defaultName: "Pulmonary Edema",
        },
        {
          name: "Fibrosis",
          active: true,
          defaultName: "Fibrosis",
        },
        {
          name: "Pleural Thickening",
          active: true,
          defaultName: "Pleural Thickening",
        },
        {
          name: "Hernia",
          active: true,
          defaultName: "Hernia",
        },
        {
          name: "Tuberculosis",
          active: true,
          defaultName: "Tuberculosis",
        },
        {
          name: "Fracture",
          active: true,
          defaultName: "Fracture",
        },
        {
          name: "Bronchitis",
          active: true,
          defaultName: "Bronchitis",
        },
        {
          name: "Bronchiectasis",
          active: true,
          defaultName: "Bronchiectasis",
        },
        {
          name: "Tuberculosis-Miliary",
          active: true,
          defaultName: "Tuberculosis-Miliary",
        },
        {
          name: "Hydro-Pneumothorax",
          active: true,
          defaultName: "Hydro-Pneumothorax",
        },
        {
          name: "Foreign Body",
          active: true,
          defaultName: "Foreign Body",
        },
        {
          name: "Broncho Pneumonia",
          active: true,
          defaultName: "Broncho Pneumonia",
        },
        {
          name: "ILD",
          active: true,
          defaultName: "ILD",
        },
        {
          name: "Opaque Hemithorax",
          active: true,
          defaultName: "Opaque Hemithorax",
        },
        {
          name: "Thymus",
          active: true,
          defaultName: "Thymus",
        },
        {
          name: "Mid Expiratory Image",
          active: true,
          defaultName: "Mid Expiratory Image",
        },
        {
          name: "Focal Emphysema",
          active: true,
          defaultName: "Focal Emphysema",
        },
        {
          name: "Subsegmental Atelectasis",
          active: true,
          defaultName: "Subsegmental Atelectasis",
        },
        {
          name: "General Emphysema",
          active: true,
          defaultName: "General Emphysema",
        },
        {
          name: "End On Vessel",
          active: true,
          defaultName: "End On Vessel",
        },
        {
          name: "Tuberculosis-Old",
          active: true,
          defaultName: "Tuberculosis-Old",
        },
        {
          name: "Right Knee",
          active: true,
          defaultName: "Right Knee",
        },
        {
          name: "Left Knee",
          active: true,
          defaultName: "Left Knee",
        },
        {
          name: "Spine",
          active: true,
          defaultName: "Spine",
        },
        {
          name: "Lumbar With Obliques",
          active: true,
          defaultName: "Lumbar With Obliques",
        },
        {
          name: "Lumbar With Flexion and Extension",
          active: true,
          defaultName: "Lumbar With Flexion and Extension",
        },
        {
          name: "General Fracture",
          active: true,
          defaultName: "General Fracture",
        },
        {
          name: "COVID Suspect",
          active: true,
          defaultName: "COVID Suspect",
        },
        {
          name: "Miscellaneous",
          active: true,
          defaultName: "Miscellaneous",
        },
        {
          name: "Opacity",
          active: true,
          defaultName: "Opacity",
        },
        {
          name: "Surgical Emphysema",
          active: true,
          defaultName: "Surgical Emphysema",
        },
        {
          name: "Lung Emphysema",
          active: true,
          defaultName: "Lung Emphysema",
        },
      ],
      allStudies: {
        pageSize: 50,
        pageNo: 1,
        searchResults : [
              {
                id: 441,
                patientName: "NAME NONE",
                patientId: "6-1559-27 DEC 19-26",
                patientSex: "M",
                studies: [
                  {
                    id: 450,
                    patientName: "NAME NONE",
                    patientId: "6-1559-27 DEC 19-26",
                    patientSex: "M",
                    patientAge: "056Y",
                    studyDateDisplay: "27-Dec-19 17:23",
                    uploadDateDisplay: "03-Nov-22 11:15",
                    modalityId: 3,
                    studyDescription: "CHEST",
                    emergency: false,
                    nonMedicalEmergency: false,
                    aiEmergencyMax: 1,
                    aiProcessed: 1,
                    attention: false,
                    raiseAlertAttention: false,
                    edited: false,
                    expReviewDoneStatus: false,
                    modalityType: "XRAY",
                    noOfFeedbacks: 0,
                    noOfReports: 1,
                    noOfImages: 1,
                    historyChecks: 0,
                    userSpecificMessageCount: 0,
                    activeStatus: 0,
                    newMessageFlag: false,
                    reportDoneStatus: 1,
                    historyPresent: false,
                    showPredictionProb: true,
                    modality: {
                      id: 3,
                      name: "CR",
                    },
                    reportSavedBy: 720,
                    genkiStudy: false,
                    studyPredictionList: [],
                    vendorPredictionList:[],
                    studyClassificationPredictionList: [],
                    assignmentList: [
                      {
                        id: 844,
                        clientId: 599,
                        clientName: "testhospone",
                        firmId: 571,
                        firmName: "DeepTek Teleradiology",
                        providerId: "R720",
                        providerName: "Test Radiologist One",
                        assignmentDateDisplay: "03-Nov-22 11:15",
                        colorClassName: "morethan2hr",
                        reportDoneStatus: 1,
                        reportResubmitStatus: 0,
                        notificationSent: false,
                        closed: 0,
                        closedByProvider: false,
                      },
                    ],
                    libraryStudy: false,
                  },
                ],
              }
        ],
        totalRecords: 294,
        beep: false,
      },
      unreportedStudies: {
        pageSize: 50,
        pageNo: 1,
        searchResults: [],
        totalRecords: 0,
        beep: false,
      },
      savedStudies: {
        pageSize: 50,
        pageNo: 1,
        searchResults: [],
        totalRecords: 0,
        beep: false,
      },
      reportedStudies: {
        pageSize: 50,
        pageNo: 1,
        searchResults: [],
        totalRecords: 0,
        beep: false,
      },
      libraryStudies: {
        pageSize: 50,
        pageNo: 1,
        searchResults: [],
        totalRecords: 0,
        beep: false,
      },
      closedStudies: {
        pageSize: 50,
        pageNo: 1,
        searchResults: [],
        totalRecords: 0,
        beep: false,
      },
    },
  };